import React from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader';
import PreStart from '@/utils/pre-start';
import './index.module.scss';
import Router from './router';

let App = () => {
  return (
    <React.StrictMode>
      <Router />
    </React.StrictMode>
  );
};

if (process.env.NODE_ENV === 'development') {
  App = hot(module)(App);
}

PreStart().then(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
